import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';

export const HomeRoutes = [
  {
    path: 'home',
    component: HomeComponent,
    title: $localize`:@@app.route.home:Inicio`,
    data: {
      icon: 'dashboard',
      linkText: $localize`:@@app.route.home:Inicio`
    }
  }
] as Routes;
